// (Eliminado: useEffect duplicado fuera del componente)

import React, { createContext, useCallback, useContext, useMemo, useState, useEffect } from "react";
import ProductDetailModal from "../components/ProductDetailModal/ProductDetailModal";

interface ProductDetailModalContextValue {
  openProductDetail: (productId: number) => void;
  closeProductDetail: () => void;
}

const ProductDetailModalContext = createContext<ProductDetailModalContextValue | null>(null);

export const ProductDetailModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedProductId, setSelectedProductId] = useState<number | null>(null);

  const openProductDetail = useCallback((productId: number) => {
    setSelectedProductId(productId);
  }, []);

  const closeProductDetail = useCallback(() => {
    setSelectedProductId(null);
  }, []);

  // Registrar función global para cierre desde StripeCheckout
  useEffect(() => {
    window.closeProductDetailModal = closeProductDetail;
    return () => {
      if (window.closeProductDetailModal === closeProductDetail) {
        delete window.closeProductDetailModal;
      }
    };
  }, [closeProductDetail]);

  const value = useMemo(
    () => ({ openProductDetail, closeProductDetail }),
    [openProductDetail, closeProductDetail],
  );

  return (
    <ProductDetailModalContext.Provider value={value}>
      {children}
      <ProductDetailModal
        isOpen={selectedProductId !== null}
        productId={selectedProductId}
        onClose={closeProductDetail}
      />
    </ProductDetailModalContext.Provider>
  );
};

export const useProductDetailModal = () => {
  return useContext(ProductDetailModalContext);
};